class BESSAppComponent extends BESSAppBase {

    static register = null;

    static #loadRegister() {
        BESSAppComponent.register = [
            new BESSAppMenuContact(),
            new BESSAppMenuToggleComponent(),
            new BESSAppMapLocation(),
            new BESSAppDropdown(),
            new BESSAppThemeSelect(),
            new BESSAppRoomPassIndicator(),
            new BESSAppToolNotesLink(),
            new BESSAppTooltip(),
            new BESSAppProjectsMap(),
            new BESSAppNewProjectComponent(),
            new BESSAppCalcReportSearch(),
            new BESSAppTogglePassword(),
            new BESSAppNavSearch(),
            new BESSAppToggleRevisions(),
            new BESSAppProjectSaveAs(),
        ]
    }

    static initialiseAll() {
        let body = $('body');
        BESSAppComponent.initialiseFor(body);
    }

    static initialiseFor(node) {
        if (BESSAppComponent.register === null) {
            BESSAppComponent.#loadRegister();
        }
        _.forEach(BESSAppComponent.register, (x) => x.initialise(node));
    }

    constructor(selector) {
        super();
        this.selector = selector;
    }

    isPresent(node) {
        return node.find(this.selector).length > 0;
    }

    initialise(node) {
        this.doInitialise(node);
    }

    doInitialise(node) {
        node.find(this.selector).each(function (x, componentNode) {
            componentNode = $(componentNode);
            //this.log("Initialising", componentNode);
            this.setupComponent(componentNode);

        }.bind(this))
    }

    setupComponent(componentNode) {
    }
}